import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/knowledge',
    redirectTo: '/knowledge/all',
  },
];

export default redirects;
